import { Link } from "react-router-dom";
import { Mail, MapPin, MessageCircle, Instagram, Facebook, Linkedin, Youtube } from "lucide-react";
import { COMPANY, waLink } from "@/lib/config";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-brand-navy/40 mt-24" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <Link to="/" className="flex items-center mb-4">
            <img
              src={COMPANY.logoFull}
              alt="Digitify My Biz"
              className="h-10 w-auto object-contain"
            />
          </Link>
          <p className="text-sm text-slate-400 leading-relaxed">
            We turn Meta Ads into closings for real estate professionals with automated WhatsApp funnels & CRM integration.
          </p>
          <div className="flex items-center gap-3 mt-5">
            {[Instagram, Facebook, Linkedin, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="/#"
                className="h-9 w-9 grid place-items-center rounded-full bg-white/5 text-slate-300 hover:bg-brand-cyan hover:text-brand-slate transition-colors"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-heading font-bold text-white mb-4">Services</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li><a href="/#services" className="hover:text-brand-cyan transition-colors">Meta Ads Management</a></li>
            <li><a href="/#services" className="hover:text-brand-cyan transition-colors">WhatsApp Nurturing Funnels</a></li>
            <li><a href="/#services" className="hover:text-brand-cyan transition-colors">CRM Integration</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-white mb-4">Company</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li><Link to="/products" className="hover:text-brand-cyan transition-colors">Products</Link></li>
            <li><Link to="/blog" className="hover:text-brand-cyan transition-colors">Blog</Link></li>
            <li><a href="/#faq" className="hover:text-brand-cyan transition-colors">FAQ</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-white mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-brand-cyan" /> {COMPANY.email}</li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-brand-cyan" /> {COMPANY.address}</li>
          </ul>
          <a
            href={waLink("Hi Digitify My Biz! I'd like a free strategy call.")}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-whatsapp"
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-brand-whatsapp/15 text-brand-whatsapp border border-brand-whatsapp/30 px-4 py-2 text-sm font-semibold hover:bg-brand-whatsapp/25 transition-colors"
          >
            <MessageCircle className="h-4 w-4" /> Chat on WhatsApp
          </a>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} {COMPANY.name}. A brand by AMD Global Net Pvt. Ltd.</p>
          <div className="flex items-center gap-5">
            <a href="/#" className="hover:text-slate-300">Privacy Policy</a>
            <Link to="/login" className="hover:text-slate-300" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
